export default __webpack_public_path__ + "static/header.berufsreise-be91d0bece088d438e3def6f633c0f95.jpg";